import { Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

import { SettingsRulesService, SettingsRulesEditorService } from '@app/services/settings/srules.service';

import * as fromRulesModel from '@app/models/rules';


@Component({
  selector: 'settings-rules-rule-form-conditions-main',
  templateUrl: './conditions-main.component.html',
  styleUrls: ['./conditions-main.component.scss'],
})
export class SettingsRulesRuleFormConditionsMainComponent implements OnInit, OnDestroy {

	public readonly STATUS_LOADING = 0;
	public readonly STATUS_DONE = 1;

    // @Input() creator: RuleCreator;
    @Input() form: FormGroup;

    protected rule: fromRulesModel.RuleEvent = null;

    public availableConditions: Array<fromRulesModel.AvailableRuleEventCondition> = [];
    public conditionForms: Array<fromRulesModel.AvailableRuleItemForm> = [];
    public event: fromRulesModel.AvailableCurrentEventConfig = null;
    public conditionsControlValues: Array<any> = [{label:'OR',value:'OR'},{label:'AND',value:'AND'}];

    public currentEventConditions:  Array<fromRulesModel.AvailableRuleEventCondition> = [];
    public status: number = 0;

    private conditionsSubscriptor: Subscription;
    private editingSubscriptor: Subscription;
    private availableConditionsSubscriptor: Subscription;
    private currentEventSubscriptor: Subscription;


    constructor(public srulesSrv: SettingsRulesService, protected editorSrv: SettingsRulesEditorService){}

    ngOnInit(){
        this.conditionsSubscriptor = this.srulesSrv.selectConditionsEditForms().subscribe((conditionForms: fromRulesModel.AvailableRuleItemForm[] ) => {
            this.conditionForms = conditionForms;
            this.initView();
        });

        this.availableConditionsSubscriptor = this.srulesSrv.selectAvailableConditions().subscribe((availConditions: fromRulesModel.AvailableRuleEventCondition[] ) => {
            this.availableConditions = availConditions;
            this.initView();
        });

        this.editingSubscriptor = this.srulesSrv.selectEditing().subscribe((currentRule: fromRulesModel.RuleEvent) => {
            this.rule = currentRule;
        });

        this.currentEventSubscriptor =  this.srulesSrv.selectEditingEvent().subscribe((currentEvent: fromRulesModel.AvailableCurrentEventConfig) => {
            this.event = currentEvent;
            this.initView();
        });

    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.editingSubscriptor.unsubscribe();
        this.conditionsSubscriptor.unsubscribe();
        this.availableConditionsSubscriptor.unsubscribe();
        this.currentEventSubscriptor.unsubscribe();
    }

    initView() : void {
        if(this.event == null){
            this.status = this.STATUS_LOADING;
            return;
        }
        this.getEventConditions(); // set the conditions for this rule 
        this.status = (this.conditionForms?.length >= 0 && this.currentEventConditions?.length == this.event.conditions.length ) ? this.STATUS_DONE : this.STATUS_LOADING;
    }

    // private getFirstAvailableCondition() : RuleCondition {
    //     let first = this.availableConditions[0];

    //     return {
    //         variable: first.key,
    //         condition: first.options[0].key,
    //         value: first.values[0].key
    //     }
    // }

    addCondition() {
        this.editorSrv.addCondition();
    }

    removeCondition(formId: string){
        this.editorSrv.removeCondition(formId);
    }

    onConditionChange( condition: fromRulesModel.RuleCondition) {
        this.editorSrv.changeCondition(condition);
    }

    // change conditions control AND / OR
    onConditionsControlChange(conditionsControl: string){
        this.editorSrv.setConditionsControl(conditionsControl);
    }

    /**
     * this get the conditions just for the current selected event to let component know when all had been loaded
     */
    protected getEventConditions() : void {
        this.currentEventConditions = (this.event === null) ? [] : this.availableConditions.filter((ac)=> this.event.conditions.includes(ac.key));
    }

}
